import React from 'react';

export function PlusMinusIcon({ open }: { open: boolean }): React.ReactElement {
  return (
    <svg
      className="h-2.5 w-2.5"
      fill="none"
      stroke="#2C3480"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d={open ? 'M5 12h14' : 'M12 5v14M5 12h14'}
      />
    </svg>
  );
}

export function ChevronIcon({ open }: { open: boolean }): React.ReactElement {
  return (
    <svg
      className={`h-4 w-4 transition-transform duration-300 ${open ? 'rotate-180' : ''}`}
      fill="none"
      stroke="#2C3480"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
}
